'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputLabel = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  color: ', ';\n  font-family: ', ';\n'], ['\n  color: ', ';\n  font-family: ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var InputLabel = exports.InputLabel = _styledComponents2.default.div(_templateObject, function (props) {
  return props.theme.color.secondary;
}, function (props) {
  return props.theme.font.bold;
});
InputLabel.displayName = 'InputLabel';


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-single-select/styles.js
// module id = 3036
// module chunks = 4